import * as types from "../../actions/actionTypes";

const initialData = {
  data: { data: [] }
};
const initialState = {
  loading: true,
  error: "",
  data: initialData
};

const PettyCashierVatReview = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_VAT_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        data: action.pageNumber ? state.data : initialData
      };
    case types.PETTY_CASHIER_VAT_REVIEW_SUCCESS:
      return { ...state, loading: false, data: action.payLoad };
    case types.PETTY_CASHIER_VAT_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default PettyCashierVatReview;
